import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/static/images/default/logo-mbk-white.svg")